import { useQuery } from '@tanstack/react-query';
import api from './axios';

/**
 * Current tenant logo as an object URL, or null when none is set.
 * Fetched through axios so the JWT and tenant headers are attached.
 */
export function useTenantLogo() {
  return useQuery<string | null>({
    queryKey: ['tenant-logo'],
    queryFn: async () => {
      try {
        const res = await api.get('/settings/logo', { responseType: 'blob' });
        return URL.createObjectURL(res.data as Blob);
      } catch {
        return null;
      }
    },
    staleTime: 5 * 60_000,
    retry: false,
  });
}
